import axios from "axios";
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AdminPasswordChange = (prop) => {
  const InitState = {
    username: null,
    password: null,
    user: prop.username,
  };
  const [formData, setFormData] = useState(InitState);
  const [username, setUsername] = useState("");
  const [rights, setRights] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const SuccessMSG = (msg) => {
    //console.log(msg)
    toast.success(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const WarningMSG = (msg) => {
    //console.log(msg)
    toast.warning(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const FailedMSG = (msg) => {
    //console.log(msg)
    toast.error(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const [UserDetails, SetUserDetails] = useState([]);
  const fetchUserDetails = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/user/FetchAdminList`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      ////console.log("Fetched data:", response.data);// Log the fetched data
      SetUserDetails(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  useEffect(() => {
    fetchUserDetails();
    setUsername(sessionStorage.getItem("username"));
    setRights(sessionStorage.getItem("rights"));
  }, []);
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await axios
        .post(
          `${process.env.REACT_APP_API_BASE_URL}/user/AdminPasswordChange`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            SuccessMSG(res.data.message);
          }
          if (res.status === 201) {
            WarningMSG(res.data.message);
          }
          setFormData([]);
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
      event.target.reset();
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
    //console.log(formData);
    setFormData(InitState);
  };

  return (
    <div className="FormContainer">
      <ToastContainer />
      <h2 className="UserManagementFormHeadLabel">Admin Password Change</h2>
      <form className="UserManagementForm" onSubmit={handleSubmit}>
        <label className="UserManagementPageFormLables">Username </label>
        <select
          className="UserManagementPageFormInputs"
          onChange={handleChange}
          required
          id="username"
          name="username"
        >
          <option value="">Select</option>
          {UserDetails.map((items) => {
            return <option value={items.Username}>{items.Username}</option>;
          })}
        </select>
        <br />
        <label className="UserManagementPageFormLables">
          Enter New Password{" "}
        </label>
        <input
          placeholder="Password"
          onChange={handleChange}
          value={formData.password}
          required
          className="UserManagementPageFormInputs"
          type="password"
          id="password"
          name="password"
        />
        <br />
        <button
          className="UserManagementPageFormSumbit"
          title="Submit"
          type="submit"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default AdminPasswordChange;
